<template>
<div>
   <div class="custom-table governance directors-meeting medium" data-aos="fade-up" v-if="$i18n.locale=='en'" >
        <div class="table-heading">Board Nominations and Remunerations Committee Meetings:</div>
        <div class="trow head border-0 bg-green">
            <div class="th ">NAME </div>
            <div class="th text-center">MEETING No. 1/2020<br> 12/2/2020</div>
        </div>
        <div class="trow">
            <div><strong>Talal Said Al Mamari</strong><br></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
        </div>
        <div class="trow">
            <div><strong>Bader Nasser Al-Kharaf</strong></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
        </div>
        <div class="trow">
            <div><strong>Abdulrahman Mohammad Ibrahim Al Asfour</strong><br >Independent</div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
        </div>
        <div class="table-heading b-top-0">Previous Members</div>
        <div class="trow">
            <div><strong>Mehdi Alabduwani</strong></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
        </div>
        <div class="trow grey percentage">
            <div><strong>Percentage of Members in Attendance</strong></div>
            <div class="text-center"><strong>100%</strong></div>
        </div>
    </div>
    <div class="custom-table governance directors-meeting medium" data-aos="fade-up" v-if="$i18n.locale=='ar'" >
        <div class="table-heading">اجتماعات لجنة الترشيحات والمكافآت</div>
        <div class="trow head border-0 bg-green">
            <div class="th ">اسم العضو </div>
            <div class="th text-center">اجتماع رقم 2020/1<br> 2020/2/12</div>
        </div>
        <div class="trow">
            <div><strong>مهدي العبدواني (عضو سابق)</strong><br></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
        </div>
        <div class="trow">
            <div><strong>بدر ناصر الخرافي</strong></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
        </div>
        <div class="trow">
            <div><strong>طلال سعيد المعمري</strong></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
        </div>
        <div class="table-heading b-top-0">عضو سابق</div>
        <div class="trow">
            <div><strong>عبد الرحمن محمد العصفور</strong></div>
            <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
        </div>
        <div class="trow grey percentage">
            <div><strong>نسبة الحضور</strong></div>
            <div class="text-center"><strong>100<span class="ltr">%</span></strong></div>
        </div>
    </div>

</div>
</template>

<script>
export default {

}
</script>

<style>

</style>